import { graphql } from 'react-relay';
import { Environment, fetchQuery } from 'relay-runtime';

import { checkRefundQuery$data } from '@/__generated__/checkRefundQuery.graphql';

export async function checkRefund(relayEnvironment: Environment, refundId: string) {
  let result: checkRefundQuery$data['checkRefund'] | null = null;

  try {
    const data = (await fetchQuery(
      relayEnvironment,
      graphql`
        query checkRefundQuery($refundId: String!) {
          checkRefund(refundId: $refundId) {
            result
            refundStage
            refundStatus
            cancelStage
            errors {
              code
              message
            }
          }
        }
      `,
      {
        refundId
      }
    ).toPromise()) as checkRefundQuery$data;

    result = data?.checkRefund;
  } catch {
    // nothing to do
  }

  return result;
}
